import classNames from 'classnames'
import { useState } from 'react'

import { type IInsuredFilters, type IGuideMarker } from '@/app/types/dmsTypes'

import Arrow from './arrow.svg'
import style from './MarkersFilter.module.scss'
import Ssearch from './search.svg'

interface IProps {
    placeholder: string
    options: IGuideMarker[]
    insuredFilters: IInsuredFilters
    classname?: string
    onSetInsuredsFilters: (insuredFilters: IInsuredFilters) => void
    onGetInsuredsList: () => void
}

export const MarkersFilter = (props: IProps) => {
    const { options, placeholder, insuredFilters, classname, onSetInsuredsFilters, onGetInsuredsList } = props
    const [showOpts, setShowOpts] = useState<boolean>(false)
    const chosenValuesList = insuredFilters.markers ? insuredFilters.markers.split(',') : []

    const actualOptions = options.filter((opt) => !chosenValuesList.includes(opt.code))

    const onAddMarker = (color: string) => {
        onSetInsuredsFilters({
            ...insuredFilters,
            markers: `${insuredFilters.markers || ''}${insuredFilters.markers ? ',' : ''}${color}`
        })
    }
    const onRemoveMarker = (color: string) => {
        onSetInsuredsFilters({
            ...insuredFilters,
            markers: insuredFilters.markers
                ? insuredFilters.markers
                      .split(',')
                      .filter((el) => el !== color)
                      .join(',') || null
                : insuredFilters.markers
        })
    }

    return (
        <div className={classNames(style.container, classname)}>
            <div className={classNames(style.field)}>
                {chosenValuesList.length > 0 &&
                    chosenValuesList.map((color, idx) => (
                        <div
                            key={idx}
                            className={style.chosenOption}
                            style={{ background: `${color}` }}
                            onClick={() => onRemoveMarker(color)}
                        />
                    ))}
                {chosenValuesList.length < 1 && <span>{placeholder}</span>}
            </div>
            {!showOpts && (
                <div className={style.trigger} onClick={() => setShowOpts(true)}>
                    <Arrow />
                </div>
            )}
            {showOpts && (
                <div
                    className={style.searchWrapper}
                    onClick={() => {
                        onGetInsuredsList()
                        setShowOpts(false)
                    }}
                >
                    <Ssearch />
                </div>
            )}
            {showOpts && actualOptions.length > 0 && (
                <div className={style.options}>
                    {actualOptions.map((option, idx) => {
                        const { code } = option
                        return (
                            <div
                                key={idx}
                                className={style.option}
                                style={{ background: `${code}` }}
                                onClick={() => onAddMarker(code)}
                            />
                        )
                    })}
                </div>
            )}
            {showOpts && actualOptions.length < 1 && (
                <div className={style.options}>
                    <span>Все цвета выбраны</span>
                </div>
            )}
        </div>
    )
}
